/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const GaugeIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <circle cx="12" cy="16" r="1.5" />
      <path d="M13.061,14.939 L18.011,9.99" />
      <path d="M2.5,16.5 L4.5,16.5" />
      <path d="M21.5,16.5 L19.5,16.5" />
      <path d="M20.776,12.365 L18.929,13.13" />
      <path d="M15.635,7.223 L14.87,9.071" />
      <path d="M12,6.5 L12,8.5" />
      <path d="M8.365,7.223 L9.13,9.071" />
      <path d="M5.283,9.282 L6.695,10.697" />
      <path d="M3.224,12.365 L5.07,13.13" />
      <path d="M12,4.5 C5.648,4.5 0.5,9.649 0.5,16 L0.5,20.5 L23.5,20.5 L23.5,16 C23.5,9.649 18.352,4.5 12,4.5 Z" />
    </g>
  </svg>
);

export default GaugeIcon;
